<template>
  <div>
    <line-chart :styles="myStyles" :chart-data="datacollection"></line-chart>
  </div>
</template>

<script>
import axios from "axios";
import LineChart from "./LineChart.js";

export default {
  props: {
    getFrom: {
      type: String,
      default: "",
      required: true,
    },
    height: {
      type: Number,
      default: 286,
      required: false,
    },
  },
  components: { LineChart },
  data: () => ({
    datacollection: {},
  }),
  mounted() {
    axios.get(this.getFrom).then((response) => {
      let datacollection = {
        labels: response.data.labels,
        showLine: true,
        backgroundColor: "#000",
        datasets: response.data.datasets,
      };
      this.datacollection = datacollection;
    });
  },
  computed: {
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
  },
};
</script>